import React from 'react';
import AppBar from './../../components/appBar';
import {IconMenu, MenuItem, IconButton} from "material-ui";
import QrCode from './../../svgIcons/qrCode';
import screenState from './../../state/scanScreen';

export default class SearchAppBar extends AppBar {
    getTitle() {
        return (
            <div>Scan QR code</div>
        )
    }

    openScanHistory = () => {
        screenState.showHistoryDialog();
    }

    getIconElementRight() {
        return (
            <IconMenu
                iconButtonElement={<IconButton><QrCode/> </IconButton>}
                anchorOrigin={{vertical: 'top', horizontal: 'left'}}
            >
                <MenuItem primaryText="Scan history..." onClick={this.openScanHistory} />
            </IconMenu>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/scan/appBar.js